import {
  Button,
  FormControl,
  FormErrorMessage,
  Grid,
  Box,
  Center,
  Input,
  Checkbox,
  FormLabel,
  Flex,
  Spinner,
  InputGroup,
  Select,
  Heading,
  InputRightElement,
  Stack,
  Text,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { FaRegTimesCircle } from "react-icons/fa";
import { useGetState } from "../../context/useGetState";
import { createUserBio, getOcccupations } from "./service";
import { ImBackward, ImForward2 } from "react-icons/im";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import image from "../../assets/image.jpeg";
import arrow from "../../assets/arrow.svg";
import logo from "../../assets/logo.png";
import "./signupsteps.css";
import splash from "../../assets/splash.jpg";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
//import http, { AUTH_ROUTES } from "../../service/routes.constants";

function UserBio({ next, prev, previous, totalStep, ...props }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { state, dispatch } = useGetState();

  const [formValues, setFormValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [occupations, setOccupations] = useState([]);

  const navigate = useNavigate();

  // Retrieve username from sessionStorage on component initialization
  useEffect(() => {
    const savedUsername = sessionStorage.getItem("username") || "";
    const savedGoogleFullname = sessionStorage.getItem("fullname") || "";
    setFormValues((prev) => ({
      ...prev,
      username: savedUsername,
      name: savedGoogleFullname,
    }));
  }, []);

  useEffect(() => {
    async function fetchOccupations() {
      const res = await getOcccupations();
      setOccupations(res?.data);
    }
    fetchOccupations();
  }, [occupations]);

  const submit = async (values) => {
    setLoading(true);
    //create copy of form values
    const payload = {
      ...formValues,
      name: values.firstname + " " + values.lastname,
    };
    // // Remove 'username' from the payload
    delete payload.username;
    const result = await createUserBio(payload, next, prev);
    result ? navigate("/register/info") : navigate("/register/bio");
  };

  const handleNext = () => {
    next(); // Call the prev function to go back to EmailScreen
  };

  // Function to handle going back to the previous step
  const handlePrev = () => {
    previous(); // Call the prev function to go back to EmailScreen
    sessionStorage.setItem("totalStep", "userBio");
  };

  const change = (e) => {
    const { name, value } = e.target || {};
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const stage = sessionStorage.getItem("totalStep");

  const inputStyle = {
    bg: "#fff",
    color: "#000",
    _placeholder: { color: "#4F555A" },
    fontWeight: "normal",
  };
  return (
    <Center
      backgroundImage={splash}
      h={{
        base: "100vh",
        sm: "100vh",
        md: "100vh",
        lg: "100vh",
        xl: "100vh",
        "2xl": "100vh",
      }}
    >
      <Grid>
        <Box
          as="form"
          onSubmit={handleSubmit(submit)}
          backgroundColor={"#020B19"}
          mb={{ base: "0", sm: "0", md: "0", lg: "0", xl: "0", "2xl": "0" }}
          mt={{
            base: "2em",
            sm: "2em",
            md: "2em",
            lg: "2em",
            xl: "2em",
            "2xl": "2em",
          }}
          h={{
            base: "90vh",
            sm: "85vh",
            md: "90vh",
            lg: "88vh",
            xl: "80vh",
            "2xl": "80vh",
          }}
          w={{
            base: "100vw",
            sm: "100vw",
            md: "60vw",
            lg: "60vw",
            xl: "60vw",
            "2xl": "60vw",
          }}
          borderWidth={1}
          borderColor={"#66666680"}
          borderRadius={{
            base: "0",
            sm: "0",
            md: "24px",
            lg: "24px",
            xl: "24px",
            "2xl": "24px",
          }}
          boxShadow="lg"
          p={{
            base: "25px",
            sm: "15px",
            md: "40px",
            lg: "25px",
            xl: "25px",
            "2xl": "15px",
          }}
        >
          <Stack
            direction={{ base: "column", md: "row" }}
            mt={{
              base: "-1em",
              sm: "0em",
              md: "-1em",
              lg: "0em",
              xl: "0em",
              "2xl": "2em",
            }}
          >
            <Flex
              p={"2%"}
              color={"white"}
              flex={1}
              align={"center"}
              justify={"center"}
              ml={"5px"}
            >
              <Stack w={"full"} maxW={"md"}>
                <Box w={"268px"} h={"110px"}>
                  <Link to="/register/otp">
                    <Image
                      alt={"Login Image"}
                      marginBottom={"10px"}
                      width={"29px"}
                      src={arrow}
                    />
                  </Link>

                  <Heading
                    color={"#ffffff"}
                    paddingTop={1}
                    fontSize={"28px"}
                    fontFamily={"Poppins-Medium"}
                    fontWeight={500}
                    letterSpacing={0}
                    lineHeight={"normal"}
                  >
                    Personal Details
                  </Heading>
                  <Text
                    fontWeight={400}
                    fontFamily={"Poppins-Medium"}
                    color={"white"}
                    fontSize={"15px"}
                    lineHeight={"normal"}
                    letterSpacing={0}
                  >
                    Lets know more about you{" "}
                  </Text>
                </Box>
                <Flex gap={4} mb={"8px !important"}>
                  <FormControl id="firstname">
                    <FormLabel
                      fontFamily={"Poppins-Regular"}
                      fontWeight={400}
                      fontSize={"0.8em"}
                      color={"#d5d5d5"}
                      lineHeight={"normal"}
                      letterSpacing={0}
                    >
                      First name
                    </FormLabel>
                    <Input
                      {...register("firstname", { required: true })}
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                      type="text"
                    />
                    {errors.firstname && <span>This field is required</span>}
                  </FormControl>
                  <FormControl id="lastname">
                    <FormLabel
                      fontFamily={"Poppins-Regular"}
                      fontWeight={400}
                      fontSize={"0.8em"}
                      color={"#d5d5d5"}
                      lineHeight={"normal"}
                      letterSpacing={0}
                    >
                      Last name
                    </FormLabel>
                    <Input
                      {...register("lastname", { required: true })}
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                      type="text"
                    />
                    {errors.lastname && <span>This field is required</span>}
                  </FormControl>
                </Flex>

                <Flex gap={4} mb={"8px !important"}>
                  <FormControl id="occupation">
                    <FormLabel
                      fontFamily={"Poppins-Medium"}
                      fontWeight={400}
                      fontSize={"0.8em"}
                      color={"#d5d5d5"}
                      lineHeight={"normal"}
                      letterSpacing={0}
                    >
                      Occupation
                    </FormLabel>

                    <Select
                      display={"none"}
                      defaultValue={"select"}
                      onChange={change}
                      name="occupation_id"
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                    >
                      <option disabled value="select">
                        Select Occupation
                      </option>

                      <option style={{color:'black' }} value="1">User</option>
                      <option  style={{color:'black' }} value="2">Trader</option>
                    </Select>

                    <Select
                      defaultValue={"select"}
                      onChange={change}
                      name="occupation_id"
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                    >
                      <option disabled value="select">
                        Select Occupation
                      </option>
                      {occupations?.length > 0 &&
                        occupations.map((occ, index) => (
                          <option  style={{color:'black' }} key={index} value={occ.id}>
                            {occ.name}
                          </option>
                        ))}
                    </Select>

                  </FormControl>
                  <FormControl id="gender">
                    <FormLabel
                      fontFamily={("Poppins-Regular", "Helvetica")}
                      fontWeight={400}
                      fontSize={"0.8em"}
                      color={"#d5d5d5"}
                      lineHeight={"normal"}
                      letterSpacing={0}
                    >
                      Gender
                    </FormLabel>
                    <Select
                      defaultValue={"select"}
                      onChange={change}
                      name="gender_id"
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                    >
                      <option disabled value="select">
                        Select Gender
                      </option>

                      <option style={{color:'black' }}  value="1">Male</option>
                      <option style={{color:'black' }}   value="2">Female</option>
                    </Select>
                    {errors.gender && <span>This field is required</span>}
                  </FormControl>
                </Flex>

                <Text
                  fontFamily={("Poppins-Regular", "Helvetica")}
                  fontWeight={400}
                  fontSize={"0.8em"}
                  color={"#d5d5d5"}
                  lineHeight={"normal"}
                  letterSpacing={0}
                  mt={2}
                  mb={0}
                  display={"none"}
                >
                  What's your date of birth
                </Text>

                <FormControl id="dob">
                  <FormLabel
                    fontFamily={("Poppins-Regular", "Helvetica")}
                    fontWeight={400}
                    fontSize={"0.8em"}
                    color={"#d5d5d5"}
                    lineHeight={"normal"}
                    letterSpacing={0}
                  >
                    What's your date of birth
                  </FormLabel>
                  <DatePicker
                    selected={formValues?.dob ? new Date(formValues.dob) : null}
                    onChange={(date) =>
                      setFormValues((prev) => ({
                        ...prev,
                        dob: date.toISOString(),
                      }))
                    }
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Select Date"
                    required
                    name="dob"
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                    customInput={
                      <Input
                        backgroundColor={"#020B19"}
                        borderColor={"#66666680"}
                        borderWidth={1}
                        variant={"outline"}
                        type="text"
                        placeholder="Date Of Birth"
                        name="dob"
                      />
                    }
                  />
                </FormControl>

                {errors.password && (
                  <Text
                    fontFamily={("Poppins-Regular", "Helvetica")}
                    fontWeight={400}
                    color={"#d5d5d5"}
                    lineHeight={"normal"}
                    letterSpacing={0}
                    fontSize={14}
                  >
                    Use 8 or more characters with a mix of letters,numbers{" "}
                    <span dangerouslySetInnerHTML={{ __html: "&#038" }} />{" "}
                    symbols
                  </Text>
                )}

                <Stack spacing={6}>
                  <Stack
                    direction={{ base: "column", sm: "row" }}
                    align={"start"}
                    justify={"space-between"}
                  ></Stack>

                  <Stack
                    align={{
                      base: "center",
                      sm: "center",
                      md: "end",
                      lg: "end",
                      xl: "end",
                      "2xl": "end",
                    }}
                  >
                    <Button
                      borderRadius={24}
                      bg={"#0076FF"}
                      w={"150px"}
                      type="submit"
                      h={"50px"}
                      variant={"solid"}
                      _hover={{ background: "#7182f5" }}
                    >
                      {loading ? <Spinner /> : "Continue"}
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            </Flex>

            <Flex
              justify="center"
              align="center"
              display={["none", "none", "none", "flex"]}
            >
              <Image
                alt={"Login Image"}
                marginTop={6}
                height={"350px"}
                width={"250px"}
                objectFit={"cover"}
                src={logo}
              />
            </Flex>
          </Stack>
        </Box>
        <Flex mr={5} ml={5} justify={"space-between"}>
          <Box>
            <Select
              fontFamily={("Poppins-Regular", "Helvetica")}
              fontSize={".9em"}
              color={"white"}
              w="auto"
            >
              <option value="en"> English(Unites states)</option>
            </Select>
          </Box>
          <Box mt={2}>
            <Flex mr={10} justify={"space-evenly"}>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                color={"white"}
              >
                Help
              </Text>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                ml={"24px"}
                color={"white"}
              >
                Privacy
              </Text>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                ml={"24px"}
                color={"white"}
              >
                Terms
              </Text>
            </Flex>
          </Box>
        </Flex>
      </Grid>
    </Center>
  );
}

export default UserBio;
